import React, {useState} from "react";
import {adminGetBrokers} from "../../../services/api/admin";
import ConfirmationModal from "../../Modal/ConfirmationModal";
import {Button, TextInput} from "flowbite-react";
import {Search} from "react-feather";

const SearchAndUpdateSearchFeatureBlock = ({handleFlagUpdate}) => {

    const [searchedBrokers, setSearchedBrokers] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [isSearchVendorLoaded, setIsSearchVendorLoaded] = useState(true);
    const [selectedBroker, setSelectedBroker] = useState(null);

    const searchBrokersByTerm = async () => {
        try {
            if (searchTerm.length === 0) {
                setSearchedBrokers([]);
                return;
            }
            setIsSearchVendorLoaded(false)
            setSearchedBrokers([]);
            const {data} = await adminGetBrokers({
                term: searchTerm,
                page: 1,
                per_page: 10,
                filters: {
                    has_search_feature: 0,
                }
            });
            setIsSearchVendorLoaded(true);
            setSearchedBrokers(data);
        } catch (e) {
            setIsSearchVendorLoaded(true);
            console.error('Error fetching brokers:', e);
        }
    }

    const handleConfirm = async () => {
        try {
            await handleFlagUpdate(selectedBroker.id, true);
            setSelectedBroker(null);
            setSearchTerm('');
        } catch (e) {
            setSelectedBroker(null);
            setSearchTerm('');
        }
    }

    React.useEffect(() => {
            searchBrokersByTerm().then(r => console.log('r', r));
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [searchTerm])

    return <div className={"sl-flex sl-flex-row sl-justify-center"}>

        {selectedBroker && <ConfirmationModal
            title={`Add Search UX Feature for : ${selectedBroker.name}`}
            message={`Are you sure you want to add the Search UX Feature to this Broker?`}
            handleConfirm={handleConfirm}
            handleClose={() => {
                setSelectedBroker(null);
            }}
        />}

        <div
            className={"sl-border-1 sl-bg-gray-200 sl-border-solid sl-border-radius-8 sl-border-gray-200 sl-p-4 sl-mb-4 sl-flex sl-flex-col sl-w-120"}>
            <span className={"sl-text-md sl-p-2"}>Add the Search UX Feature to a Broker</span>

            <div className={"sl-flex sl-flex-row relative"}>

                <TextInput
                    value={searchTerm}
                    onChange={(e) => {
                        setSearchTerm(e.target.value)
                    }}
                    isProcessing={isSearchVendorLoaded}
                    className={"sl-w-92"}
                    type="text" sizing="md" placeholder={'Enter Broker name'}/>

                {searchedBrokers.length > 0 && <div
                    className={"sl-absolute sl-bg-white sl-top-12 sl-border-radius-8 sl-z-10 sl-shadow-sm sl-w-fill-available "}>
                    <div className={"sl-flex sl-flex-col"}>
                        {searchedBrokers.map((vendor) => (
                            <div
                                onClick={() => setSelectedBroker(vendor)}
                                className={"sl-hover-gray-50 sl-cursor-pointer sl-p-2 sl-border-b-1 sl-border-solid sl-border-gray-200"}>
                                {vendor.name}
                            </div>))}
                    </div>
                </div>}


                <div style={{width: '30px', marginLeft: '10px'}}>
                    <Button size="md" isProcessing={!isSearchVendorLoaded} onClick={searchBrokersByTerm}
                            className={"sl-h-10"}
                            color={"light"}>
                        {isSearchVendorLoaded && <Search size={16}/>}
                    </Button>
                </div>


            </div>
        </div>
    </div>

}

export default SearchAndUpdateSearchFeatureBlock;
